export default "__VITE_ASSET__CoOAmxgJ__"